import { render } from "./CustomerService.vue?vue&type=template&id=afc5cce0"
import script from "./CustomerService.vue?vue&type=script&lang=js"
export * from "./CustomerService.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hostess.posnania.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__